import { ViolationService } from '../../../violations-sets/violation-service/violation.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DriversService } from '../../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import * as _ from 'underscore';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { ServiceAreasService } from '../../../service-areas/service-areas-service/service-areas.service';
import { checkRole, getDistanceFromLatLonInKm, roundOffTime, weekDays } from 'src/app/utils/utils.common';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import { StaffService } from 'src/app/component/staffs/staff-service/staff.service';
import { PlannerLoadWrapperComponent } from '../planner-load-wrapper/planner-load-wrapper.component';
@Component({
  selector: 'app-planner-schedule-modal',
  templateUrl: './planner-schedule-modal.component.html',
  styleUrls: ['./planner-schedule-modal.component.css']
})
export class PlannerScheduleModalComponent implements OnInit {
  @ViewChild('plannerWrapper', { static: false }) plannerWrapper: PlannerLoadWrapperComponent;
  plannerWrapperModalObj = false;
  user: any;
  search = '';
  scheduleTripLogsObj = null;
  timeZone;

  mappers = [];
  templates = [];

  drivers = [];
  serviceAreasWiseDrivers = [];
  filtersserviceAreasWiseDriver = [];
  selectedDrivers = [];

  preServiceAreas = {};
  serviceAreaList = [];
  selectedServiceAreas = [];

  preViolations = {};

  submitted = false;
  violation = '';
  selectedMapper = null;
  selectedTemplate = null;
  @Input() preData;
  @Output() closeModal = new EventEmitter();
  planedTrips: any;
  driverTrips=[];
  selectedDriver;
  selectedDriverId = '';
  preFleet = {};

  plannedDrivers = 0;
  publishedDrivers = 0;
  days = weekDays;

  preStaffList = {};
  stationManagerList = [];
  selectedStationManager = [];
  filteredDrivers = [];
  isAllowRates = false;
  staff;
  selectedTab = 'planner';
  templateModalObj;

  constructor(
    private driverService: DriversService,
    private violationService: ViolationService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private assignTripService: AssigTripsService,
    private fleetService: FleetService,
    private staffService: StaffService

  ) { }

  ngOnInit() {
    this.getUser();
    console.log('preData:', this.preData);
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.getServiceAreaList();
          this.getDriverList();
          this.getViolationData();
          this.getMappers();
          this.getTemplates();
          this.getFleetList();
          this.getStaffList();
          this.isAllowRates = checkRole(this.user);


        }
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.drivers = data;

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getStaffList() {
    let queryParams = {
      status: 'active'
    }
    this.staffService
      .getStaffList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.staff = data;
          this.stationManagerList = data.filter(staff => ["mdispatcher","mcallcenter"].includes(staff.roles));;
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getServiceAreaList() {
    this.serviceArea
      .getServiceAreas({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.serviceAreaList = data;
          this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleet = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getViolationData() {
    this.violationService.getViolationData().subscribe((data) => {
      if (data) {
        this.preViolations = data;
      }
    })
  }

  getMappers() {
    this.assignTripService
      .getPlannerTemplates()
      .subscribe(data => {
        if (data && data.length) {
          this.mappers = data;
        }
      });
  }

  getTemplates() {
    this.assignTripService
      .getTemplates()
      .subscribe(data => {
        if (data && data.length) {
          this.templates = data;
        }
      });
  }

  closeScheduleModal(value){
    this.closeModal.emit(value)
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }


  onSelectServiceArea(service) {
    service.isSelected = !service.isSelected;
    if (service.isSelected) {
      this.selectedServiceAreas.push(service._id);
    } else {
      const idx = this.selectedServiceAreas.indexOf(service._id);
      this.selectedServiceAreas.splice(idx, 1);
    }
    this.filterDriverServiceAreasWise();
    this.autoSelectTemplateDrivers();
  }

  filterDriverServiceAreasWise() {
    this.serviceAreasWiseDrivers = [];
    this.filteredDrivers = [];
    this.selectedDrivers = [];
    this.drivers.forEach(driver => {
      const isFound = driver.serviceAreas.some(serviceId => this.selectedServiceAreas.includes(serviceId));
      if (isFound) {
        if (!this.serviceAreasWiseDrivers.find(d => d._id === driver._id)) {
          this.serviceAreasWiseDrivers.push({ ...driver, isSelected:false });
        }
      }
    });

    this.stationManagerWiseDrivers();
  }

  stationManagerWiseDrivers() {
    this.filteredDrivers = [];
    if (this.selectedStationManager && this.selectedStationManager.length) {
      for (let driver of this.serviceAreasWiseDrivers) {
        if (driver.stationManager && this.selectedStationManager.includes(driver.stationManager)) {
          this.filteredDrivers.push(driver);
        }
      }
    }
    else if (this.serviceAreasWiseDrivers.length) {
      for (let driver of this.serviceAreasWiseDrivers) {
        this.filteredDrivers.push(driver);
      }
    }
  }

  onSelectDriver(driver) {
    driver.isSelected = !driver.isSelected;
    if (driver.isSelected) {
        this.selectedDrivers.push(driver);
    } else {
      const idx = this.selectedDrivers.findIndex(d => d._id === driver._id);
        this.selectedDrivers.splice(idx, 1);
    }
  }

  selectAllServiceArea(isTrue) {
    this.selectedServiceAreas = [];
    this.serviceAreaList.forEach(serviceArea => {
      if (isTrue) {
        serviceArea.isSelected = true;
        this.selectedServiceAreas.push(serviceArea._id);
      } else {
        serviceArea.isSelected = false;
      }
    });

    this.filterDriverServiceAreasWise();
    this.autoSelectTemplateDrivers();
  }

  selectAllDrivers(isTrue) {
    this.selectedDrivers = [];
    this.filteredDrivers.forEach(driver => {
      if (isTrue) {
        driver.isSelected = true;
        this.selectedDrivers.push(driver);
      } else {
        driver.isSelected = false;
      }
    });
  }

  onSelectViolation(violation){
    this.violation = violation
  }

  onSelectMapper(mapper) {
    if (mapper) {
      this.selectedMapper = this.mappers.find(item => item._id === mapper);
    } else {
      this.selectedMapper = null;
    }
  }

  async onProceed() {
    if (this.selectedTemplate && this.selectedDrivers && this.selectedDrivers.length) {
      this.planTripsBasedOnTemplate();
      return;
    }
    if (!this.selectedDrivers || !this.selectedDrivers.length || !this.violation || !this.selectedMapper) {
      return;
    }

     this.planedTrips = {
      trips: [],
      nonCompatible: [],
       compatible: {},
       tripLogs:{}
    };

   // convert ids to trip
   for (let trip of this.preData.trips) {
     if (this.preData.selectedTrips.includes(trip._id)) {
       this.planedTrips.trips.push(trip);
     }
   }

    this.selectedDrivers.sort((a, b) =>
      a.displayName.localeCompare(
        b.displayName
      )
    );

    this.planedTrips.trips.sort((a, b) => {
     return moment(a.scheduleTime).tz(this.timeZone).diff(moment(b.scheduleTime).tz(this.timeZone));
    });

   for (let driver of this.selectedDrivers) {
     // push all non in to trips for next iteration
     if (this.planedTrips.nonCompatible.length) {
       this.planedTrips.trips.push(...this.planedTrips.nonCompatible);
       this.planedTrips.nonCompatible = [];
      }


     if (this.planedTrips.trips.length) {
       const totalDistance = 0;
       await this.filterTrips(this.planedTrips, driver,totalDistance);
     } else {
       break;
     }
   }

    this.plannedDrivers = this.getPlannedDriversCount();
    console.log('Wrapper:', this.planedTrips);
  }

  async filterTrips(planedTrips, driver, totalDistance) {
    // debugger;
    if (!planedTrips.trips.length) {
      return planedTrips;
    }

    let selectedTrip = JSON.parse(JSON.stringify(planedTrips.trips[0]));
    //remove first trip
    planedTrips.trips.splice(0, 1);

    const checkDistance = getDistanceFromLatLonInKm(selectedTrip.jobOriginLatitude, selectedTrip.jobOriginLongitude, selectedTrip.jobDestinationLatitude, selectedTrip.jobDestinationLongitude);

    let isCompatible = false;

// checks shift parameter

    // checks other paramehters
    let logs = {};

    const isFundingSourceWiseExist = await this.fundingSourcesWiseTrip(selectedTrip, driver);
    logs = { ...logs, isFundingSourceWiseExist };
    if (isFundingSourceWiseExist) {
      const isDriverShiftWiseExist = await this.checkDriverShift(selectedTrip, driver);
      logs = { ...logs, isDriverShiftWiseExist };
      if (isDriverShiftWiseExist) {
        const isServiceAreasWiseExist = await this.serviceAreasWiseTrip(selectedTrip, driver);
        logs = { ...logs, isServiceAreasWiseExist };
        if (isServiceAreasWiseExist) {
          const isSpaceTypeWiseExist = await this.spaceTypeWiseTrip(selectedTrip, driver);
          logs = { ...logs, isSpaceTypeWiseExist };
          if (isSpaceTypeWiseExist) {
            const istimeWiseTripExist = await this.timeWiseTrip(planedTrips, selectedTrip, driver, checkDistance.distance);
            logs = { ...logs, istimeWiseTripExist };
            if (istimeWiseTripExist) {
              isCompatible = true;
            }
          }
        }
      }
    }

// detail trips on base of isCompatible
    if (isCompatible) {
      if (planedTrips.compatible[driver._id]) {
        planedTrips.compatible[driver._id].trips.push(selectedTrip);
      } else {
        planedTrips.compatible[driver._id] = {
          driver,
          trips: [selectedTrip]
        }
      }
      totalDistance += checkDistance.distance;

      // check WNR trip and assign to same driver

      const isWNRExist = await this.isWNRSpaceType(selectedTrip);
      if (isWNRExist) {
        const BTripIndex = planedTrips.trips.findIndex(tr => tr.priorityClient.displayName.toLowerCase() === selectedTrip.priorityClient.displayName.toLowerCase());
        if (BTripIndex !== -1) {
          let newSelectedTrip = JSON.parse(JSON.stringify(planedTrips.trips[BTripIndex]));
          planedTrips.trips.splice(BTripIndex, 1);
          planedTrips.compatible[driver._id].trips.push(newSelectedTrip);
          const newTripDistance = getDistanceFromLatLonInKm(newSelectedTrip.jobOriginLatitude, newSelectedTrip.jobOriginLongitude, newSelectedTrip.jobDestinationLatitude, newSelectedTrip.jobDestinationLongitude);
          totalDistance += newTripDistance.distance;
        }
      }

    } else {
      planedTrips.nonCompatible.push(selectedTrip);

      // create Trip logs
      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: selectedTrip,
          logs
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: selectedTrip,
            logs
          }]
        }
      }

    }

    let isMaxFactor = this.checkTripMaxFactor(planedTrips, driver, totalDistance);
    // add trip log
    if (!isCompatible && !isMaxFactor) {
      const findLog = planedTrips.tripLogs[driver._id].reasons.find(re => re.trip._id === selectedTrip._id);
      findLog.logs = {...findLog.logs, MaxFactor: isMaxFactor}
    }

    if (planedTrips.trips.length && isMaxFactor ) {
      await this.filterTrips(planedTrips,driver,totalDistance);
    }

    return planedTrips;
  }

  checkTripMaxFactor(planedTrips, driver, totalDistance) {
    // debugger;
    let isExecute = true;
    const selectedViolation = this.preViolations[this.violation];
    // total trips check
    if (this.violation !== 'force') {
      if (selectedViolation && selectedViolation.maxPerRun) {
        if (planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips) {
          if (planedTrips.compatible[driver._id].trips.length >= selectedViolation.maxPerRun) {
            isExecute = false
          }
        }

      }


      if (selectedViolation && selectedViolation.maxDistancePerRun && totalDistance) {
        if (totalDistance >= selectedViolation.maxDistancePerRun) {
          isExecute = false
        }
      }
    }
    // // debugger;
    return isExecute;
  }

  checkDriverShift(selectedTrip, driver) {
    let isExist = false;
    //Time zone is missing
    const start = moment(this.preData.date).startOf('day');
    const end = moment(this.preData.date).endOf('day');

    if (driver.shifts && driver.shifts.length) {
      const checkTodayShift = driver.shifts.find(item => item.day == start.day() && item.isEnabled);
      if (checkTodayShift && checkTodayShift.checkin) {
        start.set({ hour: checkTodayShift.checkin.split(':')[0], minute: checkTodayShift.checkin.split(':')[1] });
        end.set({ hour: checkTodayShift.checkout.split(':')[0], minute: checkTodayShift.checkout.split(':')[1] });

        if (moment(selectedTrip.scheduleTime).tz(this.timeZone).isBetween(start, end)) {
          isExist = true;
        }

      }
    }


    // // debugger;
    return isExist;
  }

  isWNRSpaceType(selectedTrip) {
    let isExist = false;

    if (selectedTrip.spaceType && this.preData.spaceTypes[selectedTrip.spaceType] && this.preData.spaceTypes[selectedTrip.spaceType].wnr) {
      isExist = true;
    }

    return isExist;
  }

  fundingSourcesWiseTrip(selectedTrip, driver) {
    // debugger;
    let isExist = false;
    const isfundingSource = driver.fundingSources.some(d => d.name === selectedTrip.cooperate && moment(this.preData.date).isBetween(moment(d.validityRange[0]).tz(this.timeZone), moment(d.validityRange[1]).tz(this.timeZone)));
    if (selectedTrip.cooperate && isfundingSource) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        // // debugger;
        if (this.preFleet[driverFleetId].fundingSources && this.preFleet[driverFleetId].fundingSources.includes(selectedTrip.cooperate)) {
          isExist = true;
        }
      }
    }
    // // debugger;
    return isExist;
  }

  serviceAreasWiseTrip(selectedTrip, driver) {
    // // debugger;
    let isExist = false;
    if (selectedTrip.serviceArea && driver.serviceAreas.includes(selectedTrip.serviceArea)) {
      isExist = true;
    }
    // // debugger;
    return isExist;
  }

  spaceTypeWiseTrip(selectedTrip, driver) {
    // debugger;
    const selectedViolation = this.preViolations[this.violation];
    let isExist = false;

    if (selectedViolation && !selectedViolation.isCapacityViolation) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (selectedTrip.spaceType && driverFleetId) {
          isExist = this.preFleet[driverFleetId].capacities.some(capacity => capacity.spaceType === selectedTrip.spaceType);
        }
      }
    } else {
      isExist = true;
    }
    // // debugger;
    return isExist;
  }

  timeWiseTrip(planedTrips, selectedTrip, driver, tripDistance) {
    //  // debugger;
    const selectedViolation = this.preViolations[this.violation];
    let isExist = false;
    const selectedDriverTrips = planedTrips.compatible[driver._id];
    if (selectedDriverTrips === undefined || !selectedDriverTrips.trips.length) {
      isExist = true;
    } else {
      //check currenttrip is after last trip
      const lastTrip = selectedDriverTrips.trips[selectedDriverTrips.trips.length - 1];
      const newPreviousApptTime = moment(lastTrip.appointmentTime).tz(this.timeZone);

      if (this.preData.spaceTypes[lastTrip.spaceType]) {

        let loadTime = this.preData.spaceTypes[lastTrip.spaceType].loadTime;
        let unloadTime = this.preData.spaceTypes[lastTrip.spaceType].unloadTime;

        // if (loadTime) {
        //   loadTime = unloadTime.split(':');
        //   newAppointmentTime.add(loadTime[1], 'minutes').add(loadTime[0], 'hours');
        // }

        if (unloadTime) {
          unloadTime = unloadTime.split(':');
          newPreviousApptTime.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
        }
      }

//  Add break Cushion
      if (this.preViolations[this.violation].breakCushion) {
        newPreviousApptTime.add(this.preViolations[this.violation].breakCushion, 'minutes');
      }


      // if (moment(selectedTrip.scheduleTime).isAfter(newAppointmentTime)) {
      //   isExist = true;
      // }

      if (this.violation !== 'force'){
        let pickupEarly = moment(selectedTrip.scheduleTime).tz(this.timeZone).subtract(selectedViolation.pickupEarly, 'minutes');
        let pickupLate = moment(selectedTrip.scheduleTime).tz(this.timeZone).add(selectedViolation.pickupLate, 'minutes');

        let dropoffEarly = moment(newPreviousApptTime).tz(this.timeZone).subtract(selectedViolation.dropoffEarly, 'minutes');
        let dropoffLate = moment(newPreviousApptTime).tz(this.timeZone).add(selectedViolation.dropoffLate, 'minutes');

        if (moment(selectedTrip.scheduleTime).tz(this.timeZone).isAfter(newPreviousApptTime)) {
          isExist = true;
        } else if (pickupLate.isAfter(newPreviousApptTime)) {
          isExist = true;
        }

        // check onboard Time of Trip
        if (isExist && !selectedViolation.isOnboardViolation) {
          if (selectedViolation.maxOnBoardTime) {
            const travelTime = roundOffTime(tripDistance);
            if (travelTime <= selectedViolation.maxOnBoardTime) {
              isExist = true;
            } else {
              isExist = false;
            }
          }
        }

        if (isExist) {
          // check reach possibility
          const checkpossibleDistance = getDistanceFromLatLonInKm(lastTrip.jobDestinationLatitude, lastTrip.jobDestinationLongitude, selectedTrip.jobOriginLatitude, selectedTrip.jobOriginLongitude);

          const newTravelTime = roundOffTime(checkpossibleDistance.distance);

          newPreviousApptTime.add(newTravelTime, 'minutes');

          if (moment(selectedTrip.scheduleTime).tz(this.timeZone).isAfter(newPreviousApptTime)) {
            isExist = true;
          } else if (pickupLate.isAfter(newPreviousApptTime)) {
            isExist = true;
          } else {
            isExist = false;
          }
        }

      } else {
        isExist = true;
      }

    }
    // // debugger;
    return isExist;
  }

  selectedDriverTrips(key) {
    if(key){
      this.driverTrips = this.planedTrips.compatible[key].trips;
      this.selectedDriver = this.planedTrips.compatible[key].driver;
      this.selectedDriverId = this.selectedDriver ? this.selectedDriver._id : ''
    }else{
      this.driverTrips = [];
      this.selectedDriver = null;
      this.selectedDriverId = '';
    }

  }

  removeTrip(assign){
    let findTripIndex = this.driverTrips.findIndex(t => t._id === assign._id);
    this.driverTrips.splice(findTripIndex, 1);
    this.planedTrips.nonCompatible.push(assign);
  }

  assignTrip(assign){
    this.driverTrips.push(assign);
    let findTripIndex = this.planedTrips.nonCompatible.findIndex(t => t._id === assign._id);
    this.planedTrips.nonCompatible.splice(findTripIndex, 1);
  }

  liveTrip() {

    let trips = [];
    for (let item of this.driverTrips) {
      trips.push(item._id);
    }
    const payload = {
      selectedTrips: trips,
      status: 'offered',
      driver: {
        _id: this.selectedDriver._id,
        displayName: this.selectedDriver.displayName,
        profileImageURL: this.selectedDriver.profileImageURL,
      }
    }
    sweetAlert(
      "Alert",
      "Proceed with making this plan live?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) =>{
      if(result.value){
        this.assignTripService.liveTrips(payload).subscribe((data) => {
          if (data) {
            this.selectedDriver.tripStatus = 'published'
            this.plannedDrivers -= 1;
            this.publishedDrivers += 1;
            this.closeScheduleModal(false);
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        })
      }

    })


  }

  onDriverLoadTripsLive() {
    this.closeScheduleModal(false);
  }

  getPlannedDriversCount(){
    let count = 0;
    // debugger;
    if(this.planedTrips && this.planedTrips.compatible){
      count = Object.keys(this.planedTrips.compatible).filter(drId=> this.planedTrips.compatible[drId].driver.tripStatus == undefined ).length
    }
    return count;
  }

  logs() {
    this.scheduleTripLogsObj = this.planedTrips.tripLogs;
  }

  sortMethod(a, b) {
    return a.value.driver.displayName - b.value.driver.displayName
  }

  currentDayShift(shifts) {
    const currentDay = moment(this.preData.date).day();
    if (shifts) {
      let shift = shifts.find(shift => shift.day === currentDay);
      return shift;
    } else {
      return {};
    }
  }

  setTab(tab) {
    this.selectedTab = tab;
    this.plannerWrapperModalObj = tab === 'driverload' ? true : false;
      this.selectedDriverTrips(this.selectedDriverId)
  }

  closeTemplateModal() {
    this.templateModalObj = undefined;
  }

  openTemplateModal() {
    // this.templateModalObj = {
    //   drivers: this.selectedDrivers,
    //   planedTrips: this.planedTrips
    // };

    const bucket = this.planedTrips.compatible;
    const template = []
    Object.keys(bucket).forEach(b => {
      const driver = bucket[b].driver;
      const trips = bucket[b].trips;
      let members = trips.map(trip => {
        return {
          ...trip.priorityClient,
          _id: trip.client
        }
      });
      members = _.uniq(members, '_id').sort();
      template.push({
        driver: driver,
        members: members
      });
    });
    this.templateModalObj = template;
  }

  // onChangeTemplate(evt) {
  // }

  onSelectTemplate(templateId) {
    this.selectedTemplate = {};
    if (templateId) {
      const template = this.templates.find(template => template._id === templateId);
      this.selectedTemplate = template && template.mappers && template.mappers.length ? template.mappers : null;
    } else {
      this.selectedTemplate = null;
    }

    this.autoSelectTemplateDrivers();
  }

  autoSelectTemplateDrivers() {
    this.filteredDrivers.forEach(driver => driver.isSelected = false);
    if (this.selectedTemplate && this.selectedTemplate.length && this.filteredDrivers && this.filteredDrivers.length) {
      this.selectedDrivers = [];
      this.selectedTemplate.forEach(t => {
        const driver = this.filteredDrivers.find(driver => driver._id === t.driver);
        if (driver) {
          driver.isSelected = true;
          this.selectedDrivers.push(driver);
        }
      });
    }
  }

  goToPlanning() {
    this.planTripsBasedOnTemplate();
  }

  async planTripsBasedOnTemplate() {
    const driverMembers = this.selectedTemplate.reduce((obj, item) => (obj[item.driver] = item.members, obj), {});
    this.planedTrips = {
      trips: [],
      nonCompatible: [],
      compatible: {},
      tripLogs: {}
    };

    // convert ids to trips
    for (let trip of this.preData.trips) {
      if (this.preData.selectedTrips.includes(trip._id)) {
        this.planedTrips.trips.push(trip);
      }
    }

    this.selectedDrivers.sort((a, b) =>
      a.displayName.localeCompare(
        b.displayName
      )
    );

    this.planedTrips.trips.sort((a, b) => {
      return moment(a.scheduleTime).tz(this.timeZone).diff(moment(b.scheduleTime).tz(this.timeZone));
    });

    for (const driver of this.selectedDrivers) {
      const dMembers = driverMembers[driver._id];
      if (!dMembers) continue;
      let leftTrips = [];
      let matchedTrips = [];
      for (const trip of this.planedTrips.trips) {
        if (dMembers.includes(trip.client)) {
          matchedTrips.push(trip);
        }else{
          leftTrips.push(trip);
        }
      }

      if (matchedTrips && matchedTrips.length) {
        this.planedTrips.compatible[driver._id] = {
          driver,
          trips: matchedTrips
        };
      }

      this.planedTrips.trips = leftTrips;
    };
    this.planedTrips.nonCompatible = this.planedTrips.trips;
    this.planedTrips.trips = [];
    console.log(this.planedTrips);
  }

  ngOnDestroy(): void{

  }

}
